<template>
    <div class="s3">
        <input type="file"
            name="files"
            :id="fileInputID"
            class="input--labeled"
            :accept="extensions"
            @change="uploadFiles" multiple>

        <label :for="fileInputID" class="btn btn--bordered s3__button" v-if="!uploading"><i class="ico-plus_math"></i> <span> {{label}}</span></label>
        <span class="s3__error">{{error}}</span>

        <div class="s3__progress" v-if="uploading">
            <progress class="s3__progress-bar" :value="progress.value" :max="progress.max"></progress>
            <span class="s3__progress-status">{{status}}</span>
        </div>
    </div>
</template>

<script>
import AWS from 'aws-sdk';
const MAX_FILE_TRIES = 1;

export default {
	props: {
		value: null,
		extensions: {
			type: String,
			default: '.png, .jpeg, .jpg, .JPG, .PNG, .JPEG'
		},
		label: {
			type: String,
			default: 'Add photos'
		},
		single: {
			type: Boolean,
			default: false
		}
	},
	data: function() {
		return {
			fileInputID: 's3__input-' + this._uid,
			s3: null,
			s3FilesPaths: [],
			files: [],
			fileIndex: 0,
			fileTries: 0,
			uploading: false,
			status: 'Uploading...',
			error: '',
			progress: {
				value: 0,
				max: 100,
				maxBytes: 0,
				lastFileSize: 0
			},
			extensionsArray: []
		}
	},
	mounted: function() {
		// setup S3
		this.s3 = new AWS.S3({ params: { Bucket: this.config.aws.bucket } });

		// extensions array
		this.extensionsArray = this.extensions.split(',').map(function(x) { return x.trim(); });
	},
	methods: {
		uploadFiles: function(e) {
			var self = this;
			this.files = e.target.files;

			// check file Types
			if (this.invalidFileTypes(this.files)) {
				this.error = 'Uh oh, you are trying to upload an incorrect file format. Please check the files are: ' + this.extensions;
				return;
			}

			// update status variables
			this.fileIndex = 0;
			this.fileTries = 0;
			this.status = 'Uploading...';
			this.error = '';
			this.progress.value = 0.0;
			this.progress.maxBytes = Object.keys(this.files).map(function(key) { return self.files[key].size }).reduce(function(prev, curr) { return prev + curr + 0.0 });
			this.progress.lastFileSize = 0;
			this.uploading = true;
			this.s3FilesPaths = [];

			this.$emit('uploading', true);

			this.sendFile(this.fileIndex);
		},

		sendFile: function(index) {
			// check if no more files to send
			if(index + 1 > this.files.length) {
				return this.allFilesCompleted();
			}

			// get file
			var file = this.files[index];
			this.fileIndex = index;

			// send to s3
			this.uploadToS3(file);
		},

		invalidFileTypes: function(files) {
			var self = this;

			return Object.keys(files).some(function(index) {
				var fileExtension = files[index].name.split('.').pop();
				return self.extensionsArray.indexOf('.' + fileExtension) === -1;
			});
		},

		uploadToS3: function(file) {
			var filename = file.name.replace(/\s/g, '_');
			var key = (+ new Date()) + '_' + filename;
			var s3Args = {
				Key: key,
				Body: file,
				ContentType: file.type,
				ACL: 'public-read',
				CacheControl: 'max-age=86400'
			};

			var s3Handle = this.s3.upload(s3Args);
			s3Handle.on('httpUploadProgress', this.updateUploadProgress);
			s3Handle.send(this.fileUploadComplete);
		},

		updateUploadProgress: function(e) {
			var singlePercentage = Math.round(e.loaded * 100 / this.progress.maxBytes);
			var loadedPercentage = this.progress.lastFileSize + singlePercentage;
			if(loadedPercentage > this.progress.value) {
				this.progress.value = loadedPercentage;
			}
		},

		fileUploadComplete: function(err, data) {
			// if err try one more time until max file tries
			if(err && this.fileTries < MAX_FILE_TRIES) {
				this.fileTries++;
				return this.sendFile(this.fileIndex);
			}

			// add s3 path if successfully
			if(!err) {
				this.s3FilesPaths.push(data.Key);
			}

			// send next file
			this.fileTries = 0;
			this.progress.lastFileSize += parseInt(this.files[this.fileIndex].size * 100 / this.progress.maxBytes);
			this.sendFile(this.fileIndex+1);
		},

		allFilesCompleted: function() {
			this.progress.value = this.progress.max;
			this.uploading = false;
			if(!this.single) {
				this.$emit('input', this.value.concat(this.s3FilesPaths));
			} else if(this.s3FilesPaths.length > 0) {
				this.$emit('input', this.s3FilesPaths[0]);
			}
			this.$emit('uploading', false);
			this.$emit('complete');
		}
	}
}
</script>
